<script>
    export let iconPath;
    export let iconUpDown;
</script>

<div class="pc__icon pc__icon--up-down"><img alt="up-down" src="{iconPath}/{iconUpDown}-up-down.svg" /></div>

<div class="pc__icon pc__icon--left-1"><img alt="left-1" src="{iconPath}/alert-sm.svg" /></div>
<div class="pc__icon pc__icon--left-2"><img alt="left-2" src="{iconPath}/back-sm.svg" /></div>

<div class="pc__icon pc__icon--bottom-1"><img alt="bottom-1" src="{iconPath}/off.svg" /></div>
<div class="pc__icon pc__icon--bottom-2"><img alt="bottom-2" src="{iconPath}/auto-sm.svg" /></div>
<div class="pc__icon pc__icon--bottom-3"><img alt="bottom-3" src="{iconPath}/on.svg" /></div>

<div class="pc__led pc__led--left-1"></div>
<div class="pc__led pc__led--left-2"></div>

<div class="pc__led pc__led--bottom-1"></div>
<div class="pc__led pc__led--bottom-2"></div>
<div class="pc__led pc__led--bottom-3"></div>